import { Button, Input } from "@heroui/react";
import { useNotification, useUpdatePassword } from "@refinedev/core";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { IconEye, IconEyeClosed } from "@tabler/icons-react";
import { useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object().shape({
  password: Yup.string().required(),
  repeatPassword: Yup.string()
    .test("repeatPassword", "Passwords must match", function (value) {
      return this.parent.password === value;
    })
    .required(),
  hash: Yup.string().required(),
});

export const ResetPasswordForm = ({ hash }: { hash: string }) => {
  const { mutate: updatePassword, isLoading } = useUpdatePassword<{
    password: string;
    repeatPassword: string;
    hash: string;
  }>();

  const form = useForm({
    defaultValues: { password: "", repeatPassword: "", hash },
    resolver: yupResolver(schema),
  });

  const { handleSubmit } = form;
  const { open } = useNotification();

  return (
    <>
      <h1 className={"text-2xl mb-5 text-center"}>Reset password</h1>
      <FormProvider {...form}>
        <form
          onSubmit={handleSubmit(
            (data) => updatePassword(data),
            (error) => {
              console.log(error);
              open?.({
                message: error?.root?.message || "An error occured",
                type: "error",
              });
            }
          )}
        >
          <div className={"flex flex-col gap-4 mb-6"}>
            <PasswordInput name="password" label={"Enter password"} />
            <PasswordInput name="repeatPassword" label={"Repeat password"} />
          </div>
          <Button
            size={"lg"}
            color={"secondary"}
            type={"submit"}
            fullWidth={true}
            isDisabled={isLoading}
            isLoading={isLoading}
          >
            Reset
          </Button>
        </form>
      </FormProvider>
    </>
  );
};

const PasswordInput = ({ name, label }: { name: string; label: string }) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    formState: { errors },
    register,
  } = useFormContext();

  return (
    <Input
      label={label}
      variant="bordered"
      isInvalid={!!errors?.[name]?.message}
      errorMessage={errors?.[name]?.message as string}
      endContent={
        <button
          className="focus:outline-none"
          type="button"
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? (
            <IconEyeClosed className="text-2xl text-default-400 pointer-events-none" />
          ) : (
            <IconEye className="text-2xl text-default-400 pointer-events-none" />
          )}
        </button>
      }
      type={isVisible ? "text" : "password"}
      className="max-w-sm"
      {...register(name)}
      name={name}
    />
  );
};
